let words =
  "towardtheenDofthe19thceNturyItbecameclearthatatomsarenotindivIsible"

function getRandomId() {
  let randomId = []
  for (let i = 0; i <= 10; i++) {
    let randomNum = Math.floor(Math.random() * words.length)
    randomId.push(randomNum)
    randomId.push(words[randomNum])
  }

  return randomId.join("")
}

export { getRandomId }
